module.exports = __webpack_public_path__ + "img/outlook.d0417d41.svg";